module.exports = __webpack_public_path__ + "media/images/element/exam-7dec4fb0cdbb8638900995ce0bba631f.svg";